'use strict';

var util = require('../../util/property-util');

module.exports = /*@ngInject*/ ["$window", function ($window) {
    return {
        restrict: 'EA',
        scope: {
            excludeClass : '='
        },

        link: function (scope, iElement) {
            var parent = iElement.parent();


            function init(){
                "use strict";
                var clientHeight = parent[0].clientHeight;
                var classList = parent[0].classList;
                while(Number(clientHeight) == 0 || (util.isDefined(scope.excludeClass) && classListContainsExcludeClass(classList, scope.excludeClass))){
                    parent = parent.parent();
                    clientHeight = parent[0].clientHeight;
                    classList = parent[0].classList;
                }
            }

            function calculateHeight () {
                "use strict";
                var clientHeight = parent[0].clientHeight;
                iElement.css(
                    {
                        height: clientHeight
                    }
                );
            }

            function classListContainsExcludeClass(classList, classes){
                "use strict";
                var found = false;
                classes.some(function(className){
                   if(classList.contains(className)){
                       found = true;
                       return true;
                   }
                });
                return found;
            }

            scope.$on('$destroy', function () {
                window.angular.element($window).off('resize', handleResize);
            });

            window.angular.element($window).on('resize', handleResize);

            function handleResize(){
                "use strict";
                calculateHeight();
            }

            init();
        }
    };
}];